<template>
  <div>
    <div v-if="$store.languages.length > 0">
      <select class="select"  v-on:change="updateLanguage()" ref="languagePicker">
      <option v-for="(language,index) in $store.languages" :key="index" v-bind:value="language.id">{{language.name}}</option>
      </select>
    </div>
    <b v-if="$store.languages.length == 0">Please add a language</b>
  </div>
</template>
<script>
  export default {
    name: 'languageSelector',
    mounted() {
      this.$store.getLanguages();
    },
   
    methods:{
      updateLanguage(){
        if(this.$refs.languagePicker !== undefined){
          this.$store.preferredLanguage = this.$refs.languagePicker.value
        }
      }
    },
  updated() {
      if (this.$el != null) {
        const selector = this.$el.querySelector("select")
        if(selector){
          M.FormSelect.init(selector, {});
        }
        this.updateLanguage()
      }
    }

  }
</script>




// WEBPACK FOOTER //
// src/components/LanguageSelector.vue